import { initializeApp } from 'firebase/app';
import { getAnalytics, Analytics } from 'firebase/analytics';

// Declarações globais para configurações injetadas pelo CI/CD
declare global {
  interface Window {
    __FIREBASE_CONFIG__?: {
      apiKey?: string;
      authDomain?: string;
      projectId?: string;
      storageBucket?: string;
      messagingSenderId?: string;
      appId?: string;
      measurementId?: string;
    };
  }
}

// Função para obter configuração do Firebase
function getFirebaseConfig() {
  // 1. Configuração injetada pelo CI/CD no HTML (PRIORIDADE MÁXIMA)
  if (window.__FIREBASE_CONFIG__) {
    return window.__FIREBASE_CONFIG__;
  }
  
  // 2. Configuração injetada pelo CI/CD no runtime-config.js (SEGUNDA PRIORIDADE)
  if (window.__RUNTIME_CONFIG__?.firebase) {
    return window.__RUNTIME_CONFIG__.firebase;
  }
  
  // 3. Variáveis de ambiente (desenvolvimento local)
  return {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyB9dKs0r7UC38ziULJBe3zU9_-0cdQnyJg",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "emprega-mecanico-dev.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "emprega-mecanico-dev",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "emprega-mecanico-dev.firebasestorage.app",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "12713227772",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:12713227772:web:3d4dff1c0832304e632e79",
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-DDY54MQSR0"
  };
}

// Configuração do Firebase
const firebaseConfig = getFirebaseConfig();

// Inicializar Firebase
const app = initializeApp(firebaseConfig);

// Inicializar Analytics
let analytics: Analytics | null = null;

// Função para inicializar analytics apenas no browser
export const initializeFirebaseAnalytics = (): Analytics | null => {
  if (typeof window !== 'undefined' && !analytics) {
    try {
      analytics = getAnalytics(app);
      
      // Ativar debug mode em desenvolvimento
      if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_FIREBASE_DEBUG === 'true') {
        console.log('🔥 Firebase Analytics DEBUG MODE ativado');
      }
      
      console.log('Firebase Analytics inicializado');
    } catch (error) {
      console.error('Erro ao inicializar Firebase Analytics:', error);
    }
  }
  return analytics;
};

// Função para obter analytics (inicializa se necessário)
export const getFirebaseAnalytics = (): Analytics | null => {
  if (!analytics) {
    return initializeFirebaseAnalytics();
  }
  return analytics;
};

// Função para verificar se analytics está disponível
export const isAnalyticsAvailable = (): boolean => {
  return analytics !== null;
};

export default app;
